import Vue from "vue";
import VueRouter from "vue-router";

function ifAuthenticated(to, from, next) {
    const currentUser = window.localStorage.getItem('token')
    if (currentUser) {
        next()
    } else {
        next({
            name: 'login',
        })
    }
}

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        };
    },
    routes: [
        {
            path: "/",
            name: "home",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/index.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/owner-resident",
            name: "ownerResident",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/ownerResident"),
            meta: {
                layout: "full",
            },
        },
        {
            path: "/owner-resident-registration",
            name: "ownerResidentRegistration",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/ownerResident/registration.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "ثبت مالک و ساکن",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/meterage",
            name: "meterage",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/meterage"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "ثبت متراژ",
                        active: true,
                    },
                ],
            },
        },
        /**
         ** 'پیش دریافت ها'
         */
        {
            path: "/prepaid",
            name: "prepaid",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/prepaid/"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "پیش دریافت ها",
                        active: true,
                    },
                ],
            },
        },

        /**
         ** 'پیش دریافت ها (تسویه بدهکاری)'
         */
        {
            path: "/prepaid/debt-settlement/:id",
            name: "debt-settlement",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/prepaid/DebtSettlement"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "تسویه بدهکاری",
                        active: true,
                    },
                ],
            },
        },

        /**
         ** 'پیش دریافت ها ( عودت وجه )'
         */
        {
            path: "/prepaid/repay/:id",
            name: "repay",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/prepaid/Repay"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: " عودت وجه ",
                        active: true,
                    },
                ],
            },
        },

        /**
         ** 'پرداخت های آنلاین'
         */
        {
            path: "/online-payments",
            name: "online-payments",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/onlinePayments"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: " پرداخت های آنلاین ",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/formula",
            name: "formula",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/formula"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "ثبت فرمول",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/user/contact-book",
            name: "contactBook",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/user/ContactBook.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "کاربر",
                breadcrumb: [
                    {
                        text: "دفتر تلفن",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/user/user-profile",
            name: "userProfile",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/user/UserProfile.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "کاربر",
                breadcrumb: [
                    {
                        text: "پروفایل",
                        active: true,
                    },
                ],
            },
        },

        {
            path: "/account-summaries",
            name: "accountSummaries",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/AccountSummaries.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "صورتحساب",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },

        {
            path: "/account-details",
            name: "accountDetails",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/AccountDetails.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "تراکنش‌ها",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },

        {
            path: "/account-expenses",
            name: "accountExpenses",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/AccountExpenses.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "هزینه‌ها",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/second-page",
            name: "second-page",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/SecondPage.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "Second Page",
                breadcrumb: [
                    {
                        text: "Second Page",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/debt-registration",
            name: "debtRegistration",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/DebtRegistration/index.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/debt-registration/other",
            name: "debtRegistrationOther",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/OtherRegistration/OtherCharge.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/debt-registration/other/store",
            name: "debtRegistrationOtherStore",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/OtherRegistration/OtherChargeStore.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/debt-registration/other/update",
            name: "debtRegistrationOtherUpdate",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/OtherRegistration/OtherChargeUpdate.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/debt-registration/list",
            name: "debtRegistrationList",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/DebtRegistration/List.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/debt-registration/civil/store",
            name: "debtRegistrationCivilStore",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/CivilRegistration/CivilChargeStore.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/debt-registration/current/store",
            name: "debtRegistrationCurrentStore",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/DebtRegistration/CurrentChargeStore.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/bill-debt-registration/registry",
            name: "billDebtRegistry",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/BillDebtRegistration/BillDebtRegistry.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/register",
            name: "register",
            component: () => import("@/views/Login.vue"),
            meta: {
                layout: "full",
            },
        },
        {
            path: "/login",
            name: "login",
            // component: () => import("@/views/authentication/login.vue"),
            component: () => import("@/views/Login.vue"),
            meta: {
                layout: "full",
            },
        },
        {
            path: "/select-building",
            name: "select-building",
            component: () => import("@/views/SelectBuilding.vue"),
            meta: {
                layout: "full",
            },
        },
        {
            path: "/create-building",
            name: "create-building",
            component: () => import("@/views/CreateBuilding.vue"),
            meta: {
                layout: "full",
            },
        },
        {
            path: "/create-unit",
            name: "create-unit",
            component: () => import("@/views/CreateUnit.vue"),
            meta: {
                layout: "full",
            },
        },
        {
            path: "/error-404",
            name: "error-404",
            component: () => import("@/views/error/Error404.vue"),
            meta: {
                layout: "full",
            },
        },
        {
            path: "*",
            redirect: "error-404",
        },
        {
            path: "/receive-debt",
            name: "receiveDebt",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/ReceiveDebt/index.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/receive-debt/registery",
            name: "receiveDebtRegistry",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/ReceiveDebt/ReceiveDebtRegistry.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/costs",
            name: "costs",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/Cost/index.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/cost/registry",
            name: "costRegistry",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/Cost/CostRegistry.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/cost/update",
            name: "costUpdate",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/Cost/CostUpdate.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/debtor",
            name: "debtor",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/ReceiveDebt/Debtor.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },

        {
            path: "/expenses-season",
            name: "expenses-season",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/ExpensesSeason.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },

        {
            path: "/bill-registration",
            name: "bill-registration",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/dashboard/BillRegistration.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },

        {
            path: "/management-report",
            name: "management-report",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/ManagementReport/Index.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },

                ],
            },
        },

        {
            path: "/bill",
            name: "Bill",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/Bill/Index.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },

        {
            path: "/success",
            name: "success-page",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/SuccessComponent.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },

        {
            path: "/bill/persons",
            name: "BillPersons",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/Bill/Persons.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },

        {
            path: "/bill/units",
            name: "BillUnits",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/Bill/Units.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "داشبورد",
                        active: true,
                    },
                ],
            },
        },

        /**
         ** 'اطلاعیه ها'
         */
        {
            path: "/announcement",
            name: "Announcement",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/Announcement"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "اطلاعیه",
                        active: true,
                    },
                ],
            },
        },
        /**
         ** 'ثبت/ویرایش اطلاعیه '
         */
        {
            path: "/announcement/edit-add",
            name: "edit-add-announcement",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/Announcement/Edit-Add.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "اطلاعیه",
                        active: true,
                    },
                ],
            },
        },
        /**
         ** 'ویرایش اطلاعات ساختمان'
         */
        {
            path: "/building/edit",
            name: "edit-building",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/Building/Edit.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "اطلاعات ساختمان",
                        active: false,
                    },
                ],
            },
        },
        /**
         ** 'جابجایی مدیر ساختمان'
         */
        {
            path: "/building/manager",
            name: "manager-building",
            beforeEnter: ifAuthenticated,
            component: () => import("@/views/Building/Manager.vue"),
            meta: {
                layout: "vertical",
                pageTitle: "",
                breadcrumb: [
                    {
                        text: "جابجایی مدیر",
                        active: false,
                    },
                ],
            },
        },

    ],
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

export default router;
